import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppHeader from './AppHeader';
import ProfileDialog from './ProfileDialog';
import axios from 'axios';
import { useToast } from './ToastContext';
import { FaChartLine, FaUser, FaHeadset } from 'react-icons/fa';
import { FiArrowRight } from 'react-icons/fi';
import './../Styles/EmployeeProjects.css';

const apiUrl = process.env.REACT_APP_API_URL;

const EmployeeProjects = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [employeeInfo, setEmployeeInfo] = useState({});
  const [isProfileDialogOpen, setProfileDialogOpen] = useState(false);

  useEffect(() => {
    const employeeId = localStorage.getItem('employeeId');
    if (employeeId) {
      axios.get(`${apiUrl}/api/employee-info/${employeeId}`)
        .then(response => {
          setEmployeeInfo(response.data);
        })
        .catch(error => console.error('Error fetching employee info:', error));
    }
  }, []);

  const handleOpenProfileDialog = () => setProfileDialogOpen(true);
  const handleCloseProfileDialog = () => setProfileDialogOpen(false);

  // Derive first name from full_name
  const firstName = employeeInfo.full_name ? employeeInfo.full_name.split(' ')[0] : 'Employee';

  return (
    <div className="ep-container">
      <AppHeader
        title="Tconnect"
        employeeInfo={employeeInfo}
        onProfileClick={handleOpenProfileDialog}
      />
      
      <main className="ep-main">
        {/* Decorative background elements */}
        <div className="ep-bg-dots ep-bg-dots-left"></div>
        <div className="ep-bg-dots ep-bg-dots-right"></div>
        <div className="ep-bg-blob ep-bg-blob-right"></div>
        <div className="ep-bg-blob ep-bg-blob-left"></div>

        <div className="ep-content">
          <div className="ep-welcome-section">
            <h1 className="ep-welcome-title">Welcome, <span>{firstName}!</span></h1>
            <p className="ep-welcome-subtitle">Select a module to get started</p>
          </div>

          <div className="ep-cards-grid">
            {/* PMS Card */}
            <div className="ep-card">
              <div className="ep-card-icon-wrapper pms-icon-wrapper">
                 <div className="ep-icon-inner">
                    <FaChartLine className="ep-icon-chart" />
                    <FaUser className="ep-icon-user" />
                 </div>
              </div>
              <h2 className="ep-card-title pms-title">PMS</h2>
              <p className="ep-card-subtitle">Performance Management System</p>
              <hr className="ep-card-divider pms-divider" />
              <p className="ep-card-desc">
                Manage goals, track performance, conduct reviews and drive employee growth.
              </p>
              <button className="ep-card-btn pms-btn" onClick={() => {
                const role = localStorage.getItem('userRole');
                const isMainManager = localStorage.getItem('isMainManager');
                if (role === 'admin' && (isMainManager === '1' || isMainManager === 1)) {
                  navigate('/main-manager');
                } else if (role === 'admin') {
                  navigate('/admin');
                } else if (role === 'lead') {
                  navigate('/lead-dashboard');
                } else if (role === 'hr') {
                  navigate('/hr-dashboard');
                } else {
                  navigate('/employee');
                }
              }}>
                Go to PMS <FiArrowRight className="ep-btn-icon" />
              </button>
            </div>

            {/* Service Desk Card */}
            <div className="ep-card disabled-card">
              <div className="ep-coming-soon-badge">COMING SOON</div>
              <div className="ep-card-icon-wrapper sd-icon-wrapper">
                 <FaHeadset className="ep-icon-headset" />
              </div>
              <h2 className="ep-card-title sd-title">Service Desk</h2>
              <p className="ep-card-subtitle">Service Desk System</p>
              <hr className="ep-card-divider sd-divider" />
              <p className="ep-card-desc">
                Raise requests, track issues and get support from our team.
              </p>
              <button className="ep-card-btn sd-btn" onClick={() => showToast('Service Desk is coming soon.', 'info')}>
                Coming Soon
              </button>
            </div>
          </div>
        </div>
      </main>

      {isProfileDialogOpen && (
        <ProfileDialog
          onClose={handleCloseProfileDialog}
          employeeInfo={employeeInfo}
          onUpdate={(updatedData) => setEmployeeInfo(prev => ({ ...prev, ...updatedData }))}
        />
      )}
    </div>
  );
};

export default EmployeeProjects;
